import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

@Component({
    selector: 'app-question-textarea',
    templateUrl: './question-textarea.component.html',
    styleUrls: ['./question-textarea.component.scss'],
    standalone: false
})
export class QuestionTextareaComponent implements OnInit {

  @Input() question: Question;
  @Input() readonly = false;
  @Input() showLabel = false;
  @Input() editModal = false;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlName = `textarea-control-${newGuid()}`;
  value = '';

  constructor() { }

  ngOnInit(): void {
    if (this.question?.answer) {
      this.value = this.question.answer;
    }
  }

  onChange(): void {
    if (this.question && this.value) {
      this.question.answer = this.value;
      this.questionAnswer.emit(this.question);
    }
  }

}
